export const TaskStatus = {
  in_progress: 'in_progress',
  to_do: 'to_do',
  done: 'done',
  cancelled: 'cancelled',
} as const;
export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];
